import { render, staticRenderFns } from "./LoadDataError.vue?vue&type=template&id=c4babec0"
import script from "./LoadDataError.js?vue&type=script&lang=js&external"
export * from "./LoadDataError.js?vue&type=script&lang=js&external"
import style0 from "./LoadDataError.vue?vue&type=style&index=0&id=c4babec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports